import malarkey from 'malarkey'

export default class TypeWriter
{
    constructor(view,sentences)
    {
        this.view = view
        this.typewriter = this.view.querySelector('.typewrapper .text')
        this.sentences = sentences
        this.sequenceSentences = []
        // Settings
        this.options = {
            typeSpeed: 100,
            deleteSpeed: 100,
            pauseDuration: 3000,
            repeat: true
        }
        // Fns
        this.setup()
    }

    animation()
    {

        for(let i = 0; i<this.sequenceSentences.length; i++) {
            const sentence = this.sequenceSentences[i]
            this.lib.type(sentence).pause().delete()
        }
    }

    sequence()
    {
        this.sequenceSentences.push(this.typewriter.textContent)
        for(let i = 0; i<this.sentences.length; i++) {
            const sentence = this.sentences[i]
            this.sequenceSentences.push(sentence)
        }

    }

    setup()
    {
        this.sequence()
        // Init
        this.lib = malarkey((text)=>{
            if(this.typewriter.classList.contains('is--ready') === false) {
                this.typewriter.classList.add('is--ready')
            }
            this.typewriter.textContent = text
        }, this.options);
    }
}